<template>
  <div id="sub-events-page">
    <div class="content-wrapper">
      <portal to="action-buttons">
        <ul class="navbar-nav ml-md-auto">
          <li class="nav-item">
            <el-button icon="fas fa-clipboard-check" type="warning" size="small" round @click="recordsDialog = !recordsDialog"> {{ $t("registrationManagement.subeventRegistrations.records") }} ({{ $store.state.subevents.filter.totalRecords }})</el-button>
          </li>
          <!-- <li class="nav-item">
            <el-button
              icon="fas fa-plus"
              size="small"
              round
              @click="
                updateForm = null;
                modalVisible = true;
              "
            >
              Kayıt ekle</el-button
            >
          </li> -->
          <li class="nav-item">
            <el-dropdown stlye="height: 32px;">
              <el-button size="small" type="warning" round>
                <i style="font-size: 12px;" class="fas fa-exchange-alt"></i>
                {{ $t("event.components.participants.navbar.transfer.title") }}
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="importExcell(3)">
                  <i class="fas fa-upload"></i>
                  {{ $t("event.components.participants.navbar.transfer.import") }}
                </el-dropdown-item>
                <!-- <el-dropdown-item @click.native="openExcellDialog">
									<i class="fas fa-download"></i>
									{{ this.$t('event.components.participants.navbar.transfer.export') }}
								</el-dropdown-item> -->
                <el-dropdown-item v-for="(item, index) in $store.state.subevents.items" @click.native="downloadTemplate(item.id)" :key="index" :divided="index == 0 ? true : false">
                  <i class="fas fa-file-excel"></i>
                  {{ item.title }} {{ $t("event.components.participants.navbar.transfer.transferDraft") }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </li>
          <li class="nav-item">
            <el-tooltip class="item" effect="dark" :content="$t('event.components.participants.navbar.transfer.searchFilter')" placement="top">
              <el-button icon="fas fa-search" :type="$store.state.subevents.filter.searchTerm != '' && $store.state.subevents.filter.searchTerm != null ? 'success' : ''" size="small" circle @click="isFilterEnabled = !isFilterEnabled"></el-button>
            </el-tooltip>
          </li>
          <li class="nav-item">
            <el-button icon="fas fa-plus" type="primary" size="small" :loading="loading == 'createSub'" round @click="createSubEvent"> {{ $t("registrationManagement.subeventRegistrations.createSubevent") }}</el-button>
          </li>
        </ul>
      </portal>

      <div class="content animated fadeIn">
        <transition name="slide-fade">
          <div v-if="isFilterEnabled" class="card card-collapsed filter-card">
            <div class="card-header">
              <div class="card-title-container">
                <h5 class="card-title">{{ $t("registrationManagement.subeventRegistrations.filter") }}</h5>
                <span>{{ $t("registrationManagement.subeventRegistrations.filterMsg") }}</span>
              </div>
              <div class="header-elements">
                <el-button-group>
                  <el-button @click="$store.state.subevents.filter.searchTerm = ''" icon="el-icon-refresh-right" size="mini" round>{{ $t("event.buttons.reset") }}</el-button>
                  <el-button type="warning" icon="el-icon-close" size="mini" @click="isFilterEnabled = false" round></el-button>
                </el-button-group>
              </div>
            </div>

            <div class="card-body">
              <div class="row">
                <div class="form-group col-md-12">
                  <el-input clearable v-model="$store.state.subevents.filter.searchTerm" :placeholder="$t('registrationManagement.subeventRegistrations.searchPlaceholder')"></el-input>
                </div>
              </div>
            </div>
          </div>
        </transition>

        <div class="card">
          <div class="card-header">
            <div class="card-title-container">
              <h5 class="card-title">{{ $t("registrationManagement.subeventRegistrations.subevents") }}</h5>
              <span v-if="$store.state.subevents.filter.total > 0" v-html="$t('totalContent', [$store.state.subevents.filter.total])"></span>
            </div>

            <div class="header-elements">
              <el-button-group>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.helpdesk')" placement="top">
                  <el-button @click="$helpMe(null)" icon="fas fa-life-ring" size="mini" round></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.refresh')" placement="top">
                  <el-button type="success" :icon="loading == 'loadingList' ? 'el-icon-loading' : 'fas fa-redo-alt'" size="mini" @click="refreshList" round></el-button>
                </el-tooltip>
              </el-button-group>
            </div>
          </div>

          <div class="card-body" v-if="$store.state.subevents.filter.total > 0">
            <div class="custom-grid-table-header subevents-grid-template">
              <span><i v-show="loading == 'loadingList'" class="el-icon-loading"></i></span>
              <div>{{ $t("registrationManagement.subeventRegistrations.title") }}</div>
              <el-tooltip effect="dark" placement="top-start">
                <div class="tooltip-wrapper" slot="content">{{ $t("registrationManagement.subeventRegistrations.capacityMsg") }}</div>
                <span>{{ $t("registrationManagement.subeventRegistrations.capacity") }}<i class="el-icon-info"></i></span>
              </el-tooltip>
              <el-tooltip effect="dark" placement="top-start">
                <div class="tooltip-wrapper" slot="content">{{ $t("registrationManagement.subeventRegistrations.mobileRegisterMsg") }}</div>
                <span>{{ $t("registrationManagement.subeventRegistrations.mobileRegister") }}<i class="el-icon-info"></i></span>
              </el-tooltip>
              <div>{{ $t("registrationManagement.subeventRegistrations.view") }}</div>
              <div></div>
            </div>
            <draggable :list="$store.state.subevents.items" tag="div" handle=".el-icon-s-grid" class="list-group-o sub-events-container" v-bind="dragOptions" @start="dragList = true" @end="changeSubEventSort">
              <div class="item" v-for="item in $store.state.subevents.items" :key="item.id" :class="{ passive: !item.isActive }">
                <div class="table-icon">
                  <i class="burger" :class="loading == item.id ? 'el-icon-loading' : 'el-icon-s-grid'"></i>
                </div>
                <div class="img-title">
                  {{ item.title }}
                </div>
                <div class="limit">
                  <span class="isLimited" v-if="item.enableStockControl" :class="item.stock <= item.usage ? 'isOver' : ''"
                    >{{ item.stock }} <b>/ {{ item.usage }}</b></span
                  >
                  <span class="isCool" v-else><i class="fas fa-infinity"></i></span>
                </div>
                <div class="limit">
                  <span class="isMobileActive" v-if="item.enableMobileRegistrations"
                    >{{ $t("registrationManagement.subeventRegistrations.active") }}, <b :class="item.enableAutomaticApproval ? '' : 'autoDisabled'">{{ item.enableAutomaticApproval ? $t("registrationManagement.subeventRegistrations.notRequire") : $t("registrationManagement.subeventRegistrations.require") }}</b></span
                  >
                  <span class="isMobilePassive" v-else>{{ $t("registrationManagement.subeventRegistrations.passive") }}</span>
                </div>
                <div><el-switch v-model="item.isActive" :disabled="loading == item.id" @change="toggleItem(item.id)"></el-switch></div>
                <div class="action-btns">
                  <el-tooltip effect="dark" :content="$t('event.table.edit')" placement="top">
                    <el-button
                      type="primary"
                      icon="fas fa-pen"
                      circle
                      size="mini"
                      @click="
                        subEventId = item.id;
                        addNewSubEvent = true;
                      "
                    ></el-button>
                  </el-tooltip>
                  <el-tooltip effect="dark" :content="$t('event.table.delete')" placement="top">
                    <el-popconfirm @confirm="deleteItem(item.id)" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('event.textbox.toDelete')">
                      <el-button slot="reference" type="danger" :loading="loading == 'deleteSubItem' + item.id" icon="fas fa-trash" circle size="mini"></el-button>
                    </el-popconfirm>
                  </el-tooltip>
                </div>
              </div>
            </draggable>
          </div>
          <div v-else>
            <HolaconLottieNoData class="w-100" key="create-loading" :source="'holacon-event-lottie'" :title="$t('registrationManagement.subeventRegistrations.subevents')" @btnAdd="createSubEvent" @btnRefresh="refreshList()" :buttonAdd="true" :buttonRefresh="true" :loading="loading" />
          </div>
          <div class="card-footer"></div>
        </div>
      </div>
    </div>
    <!-- <el-dialog :close-on-click-modal="false" :visible.sync="modalVisible" :title="$t('addSubEvent')" width="80%" @command="dropdownClicked($event, item.type, item.id)">
      <SubEventRegistrationAdd @closeMe="modalVisible = false" @itemUpdated="itemUpdated" @itemAdded="itemAdded" :data="updateForm" />
    </el-dialog> -->
    <el-dialog :close-on-click-modal="false" :visible.sync="addNewSubEvent" :title="$t('event.tags.addSubEvent')" class="large" center modal-append-to-body destroy-on-close>
      <SubEventAddUpdate @closeDialog="addNewSubEvent = false" :id="subEventId" v-if="addNewSubEvent" />
    </el-dialog>
    <el-dialog class="large" :visible.sync="recordsDialog" :title="$t('registrationManagement.subeventRegistrations.subeventRegistration')" center modal-append-to-body destroy-on-close :close-on-click-modal="false">
      <SubEventRecords v-if="recordsDialog" @closeDialog="recordsDialog = false" />
    </el-dialog>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import SubEventAddUpdate from "../../components/SubEventAddUpdate.vue";
import SubEventRegistrationAdd from "../../components/SubEventRegistrationAdd";
import SubEventRecords from "../../components/SubEventRecords.vue";

import PaymentDetail from "../../components/PaymentDetail";
import axios from "axios";
import PageCountInfo from "../../components/PageCountInfo";
import ParticipantMini from "../../components/ParticipantMini";
import $ from "jquery";
export default {
  metaInfo: {
    title: "Sub Events"
  },
  components: {
    SubEventRegistrationAdd,
    PaymentDetail,
    PageCountInfo,
    ParticipantMini,
    SubEventAddUpdate,
    SubEventRecords,
    draggable
  },
  name: "subEvents",
  data() {
    return {
      recordsDialog: false,
      subEventId: null,
      addNewSubEvent: false,
      subUpdateForm: null,
      modalVisible: false,
      updateForm: null,
      isFilterEnabled: false,
      timeout: null,
      excelDialog: false,
      helpUrl: this.$helpUrl + "speaker",
      detailData: null,
      detailDialog: false,
      participantData: null,
      loading: false,
      dragList: false,
      subEventSort: null
    };
  },
  methods: {
    async downloadTemplate(id) {
      this.$message.info(this.$t("generic.generatingPleaseWait"));
      var res = await this.$store.dispatch("exportXlscx", { type: 17, itemId: id, queryJson: null });
      if (!res.data.alert.hasError) {
        window.open(res.data.data.url, "_blank");
      }
    },
    async createSubEvent() {
      if (this.timeout != null) clearTimeout(this.timeout);
      this.loading = "createSub";
      this.timeout = setTimeout(async () => {
        var res = await this.$store.dispatch("addUpdateSubEvent", {
          id: null,
          title: "New SubEvent Title",
          details: "New Subevent Details",
          isActive: true,
          stock: 0,
          stockControl: 0,
          enableStockControl: false,
          enableMobileRegistrations: false,
          enableAutomaticApproval: false,
          enableRegistrationAutomation: false,
          controlType: 0,
          registrationControlItems: []
        });
        this.loading = false;
        if (!res.data.alert.hasError) {
          this.subEventId = res.data.data.item.id;
          this.addNewSubEvent = true;
        }
      }, 500);
    },
    async changeSubEventSort() {
      if (this.subEventSort != null) clearTimeout(this.subEventSort);
      this.loading = "loadingList";
      this.subEventSort = setTimeout(async () => {
        var payload = [];
        this.$store.state.subevents.items.map(x => {
          payload.push(x.id);
        });
        await this.$store.dispatch("saveSubEventOrder", payload);
        await this.$store.dispatch("getSubEvents");
        this.loading = false;
      }, 500);
      this.dragList = false;
    },
    async refreshList() {
      if (this.listShort != null) clearTimeout(this.listShort);
      this.loading = "loadingList";
      await this.$store.dispatch("getSubEvents");
      this.listShort = setTimeout(async () => {
        this.loading = false;
      }, 500);
    },

    itemAddedSubEvent() {
      this.$store.dispatch("getSubEvents");
    },
    itemUpdatedSubEvent(item) {
      var subIndex = this.$store.state.subevents.items.findIndex(x => x.id == item.id);
      this.$store.state.subevents.items.splice(subIndex, 1, item);
    },
    confirmSubEventRegistration(payload) {
      this.$store.dispatch("confirmSubEventRegistration", {
        ...payload,
        context: this
      });
    },
    cancelSubEventRegistration(payload) {
      this.$store.dispatch("cancelSubEventRegistration", {
        ...payload,
        context: this
      });
    },
    prepareParticipantMini(row) {
      return {
        firstName: row.firstName,
        lastName: row.lastName,
        tagID: row.tagID,
        id: row.id
      };
    },
    itemUpdated(item) {
      var index = this.$store.state.subeventregistrations.items.findIndex(k => k.id == item.id);
      if (index != -1) {
        this.$store.state.subeventregistrations.items.splice(index, 1, item);
      }
    },
    itemAdded(item) {
      this.$store.dispatch("getSubEventRegistrations");
    },
    handleSizeChange(take) {
      this.$store.commit("setSubEventRegistrationTake", take);
    },
    handleCurrentChange(page) {
      $("html, body").animate({ scrollTop: 0 }, 350);
      this.$store.commit("setSubEventRegistrationPage", page);
    },
    async deleteItem(id) {
      this.loading = "deleteSubItem" + id;
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        await this.$store.dispatch("deleteSubEvent", id);
        this.loading = false;
      }, 500);
    },
    async toggleItem(id) {
      this.loading = id;
      await this.$store.dispatch("togglerSubEvent", id);
      setTimeout(() => {
        this.loading = false;
      }, "500");
    },
    statusChanged(value, index) {
      this.$store.dispatch("toggleSubEventRegistration", { index, value });
    },
    handleSelectionChange(items) {
      this.$store.commit("setSelectedSubEventRegistrations", items);
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.isActive) {
        return "row-active";
      }
      return "row-passive";
    }
  },
  beforeMount() {
    this.loading = "loadingScreen";
    if (this.timeout != null) clearTimeout(this.timeout);
    this.timeout = setTimeout(async () => {
      this.$store.dispatch("getSubEvents");
      this.$store.dispatch("getTags");
      this.$store.dispatch("getRegisterForm");
      this.loading = false;
    }, 500);
  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    },
    skip() {
      return (this.$store.state.subevents.filter.page - 1) * this.$store.state.subevents.filter.take;
    },
    take() {
      return this.skip + this.$store.state.subevents.items.length;
    }
  },
  watch: {
    "$store.state.subevents.filter.searchTerm": function() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.$store.dispatch("getSubEvents");
      }, 500);
    },
    "$store.state.subevents.filter.subEventIDs": function(val) {
      this.$store.dispatch("getSubEvents");
    }
  }
};
</script>

<style lang="less">
.modal-base-subevents {
  min-width: 991px !important;
  max-width: 991px !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/event/subEvents.vue